<template>
  <div class="pa-4">
    <div class="d-flex mb-4">
      <DateFilter @change-date="setDateFilter" @change="applyDateFilter" :value="dateFilter" />
    </div>
    <v-data-table
      :mobile-breakpoint="100"
      class="partnerlist-table"
      :headers="headers"
      :items="apps"
      item-key="id"
      :server-items-length="total"
      :options.sync="options"
      :footer-props="footerProps"
      :no-data-text="noDataText"
    >
      <template #top>
        <v-text-field
          dense
          single-line
          hide-details
          outlined
          v-model="search"
          label="Введите ИНН, ОГРН, наименование, логин или id пользователя"
          class="mb-4"
          clearable
        ></v-text-field>
      </template>

      <template #[`item.person_phone`]="{ value }">
        <span style="white-space: nowrap">{{ formatPhone(value) }}</span>
      </template>

      <template #[`item.state`]="{ value }">
        <StatusChip :value="value" />
      </template>

      <template #[`item.lastUpd`]="{ value }">
        <span>
          <span>{{ new Date(value).toLocaleDateString() }}</span
          ><br />
          <span class="font font--label-light font--color_light">{{ new Date(value).toLocaleTimeString() }}</span>
        </span>
      </template>
      <template #[`item.id`]="{ value }">
        <router-link class="text-link text-decoration-none" :to="`apps?id=${value}`" replace>
          <v-btn :data-value="value" text icon>
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </router-link>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import DateFilter from "@/components/common/DateFilter";
import StatusChip from "@/components/common/StatusChip";
import { formatPhone } from "@/utils/helpers";

export default {
  name: "AppsGrid",

  components: {
    DateFilter,
    StatusChip,
  },

  data() {
    return {
      footerProps: {
        itemsPerPageText: "Пользователей на странице:",
        itemsPerPageAllText: "Все",
        pageText: "{0}-{1} из {2}",
        itemsPerPageOptions: [5, 10, 15, 30, 50],
      },
      noDataText: "Нет пользователей",
      headers: [
        { text: "ИНН", value: "inn", sortable: false },
        { text: "ОГРН", value: "ogrn", sortable: false },
        { text: "Номер телефона", value: "person_phone", sortable: false },
        { text: "Статус", value: "state", sortable: false },
        { text: "Дата последнего изменения", value: "lastUpd", sortable: false },
        { text: "", value: "id", sortable: false },
      ],
    };
  },
  methods: {
    ...mapMutations("app", ["setDateFilter", "setPage", "setPageSize", "setSearchQuery"]),
    ...mapActions("app", ["appsList", "appInfo"]),

    applyDateFilter({ start, end }) {
      this.setDateFilter({ start, end });
      this.options = { page: 1, itemsPerPage: this.options.itemsPerPage };
      this.appsList();
    },

    applyAppInputFilter() {
      this.options = { page: 1, itemsPerPage: this.options.itemsPerPage };
      this.appsList();
    },
    formatPhone(value) {
      return formatPhone(value);
    },
  },
  computed: {
    ...mapState("app", ["apps", "total", "pageSize", "page", "search_query", "showApp"]),
    ...mapGetters("app", ["dateFilter"]),

    search: {
      get() {
        return this.search_query;
      },
      set(value) {
        this.setSearchQuery(value);
      },
    },

    options: {
      get() {
        return {
          page: this.page,
          itemsPerPage: this.pageSize,
        };
      },
      set({ page, itemsPerPage }) {
        this.setPage(page);
        this.setPageSize(itemsPerPage);
      },
    },
  },
  watch: {
    // вызов метода (получение данных компании) и открытие слайд панели, если в гриде кликнули по стрелке
    $route(to, from) {
      let id = to.query.id;
      if (id) {
        this.appInfo(id);
      }
    },

    // если закрыли слайд панели "Компания" возвращаем путь /cabinet/apps
    showApp(show) {
      if (!show) {
        this.$router.replace({ name: "apps" });
      }
    },

    search_query() {
      this.debouncedSearch();
    },

    options: {
      handler() {
        this.appsList();
      },
      deep: true,
    },
  },
  created() {
    this.debouncedSearch = debounce(this.applyAppInputFilter, 500);

    // вызов метода (получение данных компании) и открытие слайд панели, если скопирована ссылка c id
    let id = this.$route.query.id;
    if (id) {
      this.appInfo(id);
    }
  },
};
</script>

<style lang="scss" scoped></style>
